package one.healthium.uscreen.ui.blocks

import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.uscreen.domain.models.DividerBlock
import one.healthium.uscreen.ui.util.uscreenPadding

@Composable
fun UScreenDividerBlock(
    modifier: Modifier = Modifier,
    block: DividerBlock,
) {
    HorizontalDivider(
        modifier = modifier.uscreenPadding(block.padding),
        color = AppTheme.colors.divider,
    )
}
